<template>
  <el-dialog title="游戏数据" :visible.sync="visible" width="1110px" center>
    <div class="black-guide">
      <div class="black-guide-l">
        <div class="guide-step-content">
          <div class="mb-10 bold-title">【Blablalink】账号注册及授权开启方法：</div>
          <div class="mb-10 step-title">1、前往【Blablalink】注册账号</div>
          <img src="@/assets/black_imgs/step1.png" alt="" class="mb-10 step2" />
          <div class="mb-10 step-title">2、注册时需选择您游戏账号所在区服</div>
          <img src="@/assets/black_imgs/step2.png" alt="" class="mb-10 step2" />
          <div class="mb-10 step-title">3、注册成功后，前往【首页】并点击【shiftyPad】</div>
          <img src="@/assets/black_imgs/step3.png" alt="" class="mb-10 step3" />
          <div class="mb-10 step-title">4、前往SHIFTYPAD页面后，点击【隐私设置】并开启所有授权</div>
          <img src="@/assets/black_imgs/step4.png" alt="" class="mb-10 step4" />
          <img src="@/assets/black_imgs/step4_2.png" alt="" class="mb-10 step4" />
          <div class="mb-10 step-title">5、开启授权后，返回【首页】并点击头像进入个人中心</div>
          <img src="@/assets/black_imgs/step5.png" alt="" class="mb-10 step4" />
          <div class="mb-10 step-title">6、进入个人中心后，复制【账号ID】并在当前页面输入，即可获取游戏数据了~</div>
          <img src="@/assets/black_imgs/step6.png" alt="" class="mb-10 step4" />
        </div>
      </div>
      <div class="guide-divider"></div>
      <div class="black-guide-r">
        <div class="bind-tip">
          <div class="prefix"></div>
          <div class="suffix"></div>
          绑定游戏数据，不再错过收菜和每日任务！
        </div>
        <div class="title">
          <div class="text-bond">输入下方的【账号ID】并选择注册时选择的区服，即可获取游戏数据</div>
        </div>
        <img src="@/assets/black_imgs/step6.png" />
        <div class="select-box">
          <el-select v-model="serverId" placeholder="请选择区服">
            <el-option v-for="item in serverList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div class="input-box">
          <el-input v-model="openId" placeholder="请输入【Blablalink】账号ID"></el-input>
        </div>
        <div class="btn-wrap">
          <div class="btn link" @click="goLink">前往【Blablalink】</div>
          <div class="btn sure" @click="makeSure">已输入账号ID</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { apiAddUsername } from "@/api/blackBoxApi";

export default {
  name: "blackGuide",
  data() {
    return {
      visible: false,
      openId: "",
      serverId: "",
      serverList: [
        {
          label: "日本/韩国/北美/东南亚/全球",
          value: 0
        },
        {
          label: "香港/澳门/台湾",
          value: 1
        }
      ]
    };
  },
  watch: {
    visible(val) {
      if (val) {
        // 数据绑定埋点
        if (window.staticFn) {
          window.staticFn.customEvent("visit_nikke_data_Unbound_Pop-ups");
        }
      }
    }
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    goLink() {
      window.open("https://www.blablalink.com/", "_blank");
    },
    makeSure() {
      if (![0, 1].includes(this.serverId)) {
        return this.$message.error("请选择区服");
      }
      if (!this.openId) {
        return this.$message.error("请输入账号昵称");
      }
      apiAddUsername({ open_id: this.openId, server_id: this.serverId }).then(res => {
        if (res.code === 0) {
          this.$message.success("由于数据绑定可能存在短暂延迟 请您耐心等待约 3 分钟后，重新进入本页面查看最新数据");
          this.$emit("onAddSuccess");
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.black-guide {
  display: flex;
  justify-content: space-between;
  .black-guide-l {
    width: 47%;
    height: 440px;
    overflow-y: auto;

    .guide-step-content {
      width: calc(100% - 20px);
      color: #333333;

      .bold-title {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }

      .mb-10 {
        margin-bottom: 10px;
      }

      .title {
        font-weight: 600;
        font-size: 12px;
        color: #333333;
      }

      .step-title {
        font-weight: 400;
        font-size: 14px;
        color: rgba(51, 51, 51, 0.9);
        color: #333333;
      }

      .step2,
      .step3,
      .step4 {
        width: 100%;
        height: 100%;
      }
    }
  }

  .black-guide-r {
    width: 47%;
    flex-direction: column;
    display: flex;
    gap: 12px;
    .bind-tip {
      position: relative;
      font-size: 15px;
      color: #3490e6;
      text-align: center;
      line-height: 24px;
      background: url("~@/assets/black_imgs/stars_blue.png") no-repeat rgba(52, 144, 230, 0.15);
      background-size: 24px 24px;
      background-position: left 80px center;
      margin: 0 6px;
      .prefix,
      .suffix {
        position: absolute;
        height: 100%;
        width: 0;
        top: 0;
      }
      .prefix {
        left: 0;
      }
      .suffix {
        right: 0;
      }
      .prefix::before,
      .prefix::after,
      .suffix::before,
      .suffix::after {
        content: "";
        position: absolute;
        box-sizing: content-box;
        border: 2px solid #3490e6;
      }
      .prefix::before,
      .suffix::after {
        width: 10px;
        height: 8px;
      }
      .prefix::after,
      .suffix::before {
        width: 2px;
        height: 4px;
      }
      .prefix::before {
        left: -6px;
        top: -6px;
        border-right-width: 0;
        border-bottom-width: 0;
      }
      .prefix::after {
        left: -6px;
        bottom: -6px;
        border-top-width: 0;
        border-right-width: 0;
      }
      .suffix::before {
        top: -6px;
        right: -6px;
        border-left-width: 0;
        border-bottom-width: 0;
      }
      .suffix::after {
        bottom: -6px;
        right: -6px;
        border-top-width: 0;
        border-left-width: 0;
      }
    }
    .select-box {
      width: 100%;
      /deep/ .el-select {
        display: block;
      }
      /deep/ .el-input {
        height: 48px !important;
        background: rgba(52, 144, 230, 0.05) !important;
        border-radius: 10px !important;

        .el-input__inner {
          width: inherit;
          height: inherit;
          background: inherit;
          border-radius: inherit;
        }
      }
    }
    .input-box {
      width: 100%;
      /deep/ .el-input {
        display: block;
        height: 48px !important;
        background: #ededed !important;
        border-radius: 10px !important;

        .el-input__inner {
          width: inherit;
          height: inherit;
          background: inherit;
          border-radius: inherit;
        }
      }
    }

    img {
      display: block;
      width: 100%;
      border-radius: 10px;
    }

    .title {
      display: flex;

      .text-bond {
        font-size: 15px;
        font-weight: 600;
        color: #333333;
      }
    }

    .btn-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: auto;
      .btn {
        width: 236px;
        height: 48px;
        border-radius: 6px;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .link {
        border: 1px solid #3490e6;
        color: #3490e6;
      }

      .sure {
        color: #ffffff;
        background: #3490e6;
      }
    }
  }
  .guide-divider {
    width: 2px;
    background-color: #f2f2f2;
  }
}

/deep/ .el-dialog__title {
  font-weight: bold;
}
/deep/ .el-dialog__body {
  height: 480px;
}
</style>
